module.exports = __webpack_public_path__ + "static/img/s_9.c600d60f.png";